const GROCERIES_HERO_IMAGE_WITH_CONTAINER_URL =
  'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1785692051/corp-management-ui/Groceries%20-%20Instacart%20Hero%20Image.png';

const GROCERIES_HERO_IMAGE_FULL_URL =
  'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1785692751/corp-management-ui/Groceries%20-%20Instacart%20Hero%20Image%20No%20Container.png';

export const GROCERIES_HOW_IT_WORKS_IMAGE_URL =
  'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1785692213/corp-management-ui/Groceries%20-%20How%20It%20Works%20Illustration%20PNG.png';

export function getGroceriesHeroImageUrl(isDesktop: boolean): string {
  return isDesktop
    ? GROCERIES_HERO_IMAGE_WITH_CONTAINER_URL
    : GROCERIES_HERO_IMAGE_FULL_URL;
}
